import React, { memo } from 'react';

interface LapToggleSwitchProps {
  isEnabled: boolean;
  onToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const LapToggleSwitch: React.FC<LapToggleSwitchProps> = memo(({ isEnabled, onToggle }) => {
  return (
    <div className="workout__toggle-container">
      <label className="workout__toggle-switch">
        <input
          type="checkbox"
          checked={isEnabled}
          onChange={onToggle}
          className="workout__toggle-input"
        />
        <span className="workout__toggle-slider"></span>
      </label>
      <span className="workout__toggle-label">{isEnabled ? 'Auto-lap on' : 'Auto-lap off'}</span>
    </div>
  );
});

// Add display name
LapToggleSwitch.displayName = 'LapToggleSwitch';

export default LapToggleSwitch;
